<template>
  <div class="w-100 mt-3 d-flex flex-column text-center align-items-center">
    <span class="span-text w-100">Parsed chart data</span>
    <button class="ml-auto btn next-button" @click="downloadFile('chart_ppt.pptx')">
      Download charts
    </button>
    <div v-if="data && data.length" class="w-100 d-block align-items-center justify-content-center mt-1">
      <div
        class="mb-4"
        v-for="(item, idx) in data"
        :key="idx"
      >
        <h3 v-if="item.name">{{ item.name }}</h3>
        <BarChart
          :chart-data="item"
          :options="chart.options"
          class="bar-chart-style"
        />
      </div>
    </div>
    <div v-else class="d-flex flex-wrap flex-row align-items-center justify-content-center mt-1">
      <h3>
        No data
      </h3>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/shared/BarChart'

export default {
  name: 'RDFCharts',
  components: {
    BarChart
  },
  props: {
    data: Object,
    downloadFile: Function
  },
  data () {
    return {
      chart: {
        options: {
          scales: {
            x: {
              stacked: true
            }
          },
          tooltips: {
            enabled: true,
            mode: 'label',
            callbacks: {
              title: function (tooltipItems, data) {
                let idx = tooltipItems[0].index
                return data.labels[idx]
              }
            }
          },
          barValueSpacing: 20,
          responsive: true,
          maintainAspectRatio: false
        },
        showFilters: true,
        hideOverlay: false,
        filters: {
          metadata: '',
          metadataType: ''
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";

.bar-chart-style {
  height: 300px;
}

.next-button {
  font-family: 'Open Sans', sans-serif;
  font-weight: 900;
  line-height: 30px;
  letter-spacing: 0;
  background-color: $blueberry;
  color: white;
  text-transform: uppercase;
  border-radius: 4px;
  margin-right: 30px;
  margin-bottom: 15px;
  width: 160px;
  height: 38px;
  padding: 1px 2px;
  @media screen and (min-width: $break-lg) {
    width: 180px;
    height: 40px;
    padding: 2px 3px;
    font-size: 12px;
  }
  @media screen and (min-width: $break-xl) {
    width: 200px;
    height: 42px;
    padding: 3px;
    font-size: 13px;
  }
  @media screen and (min-width: $break-xxl) {
    width: 240px;
    height: 44px;
    padding: 3px 4px;
    font-size: 16px;
  }
  transition: background-color 0.2s linear;
  &:hover {
    background-color: #9256D9;
  }
}

.span-text {
  font-size: 1.6rem;
}

</style>
